const { cxt } = require('./context');

const phoneNumber = [
  cxt('pattern', { pattern: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/ }),
];

const phoneNumberRequired = [
  'required',
  phoneNumber,
];

const phoneNoSameValues = [
  'no-same-values',
];

module.exports = {
  phoneNumber,
  phoneNumberRequired,
  phoneNoSameValues,
};
